import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChange } from '@angular/core';
declare let $: any;

@Component({
    selector: 'app-navsearch',
    templateUrl: './navsearch.component.html',
    styleUrls: ['./navsearch.component.scss']
})
export class NavsearchComponent implements OnInit, OnChanges {

    @Input() public visible: boolean;
    @Output() public onclose = new EventEmitter<boolean>();
    public term: string;

    constructor(public elem: ElementRef) { }

    public ngOnInit() {
        $(document)
            .on('keyup', event => {
                if (event.keyCode === 27) { // ESC
                    this.closeNavSearch();
                }
            })
            .on('click', event => {
                if (!$.contains(this.elem.nativeElement, event.target)) {
                    this.closeNavSearch();
                }
            })
            ;
    }

    public closeNavSearch() {
        this.visible = false;
        this.onclose.emit();
    }

    public ngOnChanges(changes: { [propKey: string]: SimpleChange }) {
        if (changes['visible'].currentValue === true) {
            this.elem.nativeElement.querySelector('input').focus();
        }
    }

    public handleForm() {
        // handleForm
    }
}
